// Звезда избранного: горит, только если id есть в наборе (вошедшему — СЕРВЕРА, гостю — локальном); на время запроса
// заблокирована. Потолок набора (config.favorite_limits, src/session/favorites.ts): звезда не переключается, внизу —
// уведомление с числом, как в iOS. compact — малая (строка матча, шапка лиги в матч-центре): поле нажатия 36.
import { ApiError } from '../api/client';
import { t, type StringKey } from '../i18n/i18n';
import { FavoriteLimitError, type FavType, useFavorites, useToggleFavorite } from '../session/favorites';
import { haptic } from '../telegram/webapp';
import { toast } from './Toast';
import styles from './FavoriteStar.module.css';

const LIMIT_TEXT: Record<FavType, StringKey> = {
  match: 'matchCenter.limitMatch', league: 'matchCenter.limitLeague', team: 'matchCenter.limitTeam', player: 'matchCenter.limitPlayer',
};

/** Текст уведомления об ошибке звезды. */
export function favoriteErrorText(err: unknown): string {
  if (err instanceof FavoriteLimitError) return t(LIMIT_TEXT[err.type], err.limit);
  return err instanceof ApiError && err.kind === 'network' ? t('shell.offline.title') : t('shell.fav.error');
}

export function FavoriteStar({ type, id, compact = false, className }: { type: FavType; id: number; compact?: boolean; className?: string }) {
  const set = useFavorites();
  const toggle = useToggleFavorite();
  const on = set[type].includes(id);
  const size = compact ? 20 : 24;
  return (
    <button className={`${styles.star} ${compact ? styles.compact : ''} ${on ? styles.on : ''} ${className ?? ''}`} disabled={toggle.isPending}
      aria-pressed={on} aria-label={t(on ? 'shell.fav.remove' : 'shell.fav.add')}
      onClick={(e) => {
        e.stopPropagation(); // звезда внутри строки матча — строку не открываем
        haptic.impact();
        toggle.mutate({ type, id, on }, { onError: (err) => toast(favoriteErrorText(err)) });
      }}>
      <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" fill={on ? 'currentColor' : 'none'}
        stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round">
        <path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z" />
      </svg>
    </button>
  );
}
